export const ENCOUNTER_STATUS = {
  'Non Eligible': 'Non Billable',
  Active: 'Active',
  Inactive: 'Inactive',
  BILLABLE: 'Billable',
  NON_BILLABLE: 'Non Billable',
  INCOMPLETE: 'Incomplete',
};
